.ux-modal {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  left: 0;
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
  padding: $dim-10;
  pointer-events: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: $z-index-modal;

  &.ux-modal--sticky-bottom {
    justify-content: flex-end;
  }

  &.ux-modal--sticky-top {
    justify-content: flex-start;
  }

  @media (width <=767px) {
    align-items: stretch;
  }

  @media (width >=1024px) {
    padding: $dim-15;
  }

  &--closed {
    display: none;
  }

  &__backdrop {
    backdrop-filter: blur(4px);
    background: rgb(0 0 0 / 30%);
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;

    .ux-modal--opening & {
      opacity: 0;
    }

    .ux-modal--opened & {
      opacity: 1;
      transition: opacity $animationSpeed-fast ease-out;

      @container style(--trumpf-ux-animations: disabled) {
        transition-duration: 0s;
      }
    }

    .ux-modal--closing & {
      opacity: 0;
      transition: opacity $animationSpeed-fast ease-out;

      @container style(--trumpf-ux-animations: disabled) {
        transition-duration: 0s;
      }
    }

    .ux-modal--closed & {
      opacity: 0;
    }
  }

  &__outer {
    display: flex;
    max-height: 100%;
    max-width: 100%;
    position: relative;

    @media (width >=768px) {
      width: 83.3333%;
    }

    @media (width >=1024px) {
      max-width: 960px;
      width: 66.6666%;
    }
  }

  &__inner {
    align-items: stretch;
    background: $color-white;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    max-height: 100%;
    width: 100%;

    .ux-modal--opening & {
      opacity: 0;
      transform: scale(0.95);
    }

    .ux-modal--opened & {
      opacity: 1;
      transform: none;
      transition: opacity $animationSpeed-fast ease-out, transform $animationSpeed-fast ease-out;

      @container style(--trumpf-ux-animations: disabled) {
        transition-duration: 0s;
      }
    }

    .ux-modal--closing & {
      opacity: 0;
      transform: scale(0.95);
      transition: opacity $animationSpeed-fast ease-out, transform $animationSpeed-fast ease-out;

      @container style(--trumpf-ux-animations: disabled) {
        transition-duration: 0s;
      }
    }

    .ux-modal--closed & {
      transform: scale(0.95);
    }
  }

  &__head {
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    height: $dim-40;
    justify-content: flex-end;
  }

  &__slot {
    align-items: stretch;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: stretch;
    max-height: calc(100% - 40px);
    width: 100%;
  }

  &__close {
    appearance: none;
    background: transparent;
    border: 0 none transparent;
    cursor: pointer;
    height: $dim-40;
    margin: 0;
    outline: none;
    padding: 0;
    width: $dim-40;
  }

  &__multi {
    border-bottom: 1px solid $color-gray-background;
    padding: 15px 0;
    width: 100%;

    .ux-steps {
      margin: 0 auto;
      max-width: 500px;
    }
  }

  &--no-gutter-top .ux-modal__head {
    position: absolute;
    width: 100%;
  }
}